import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Sparkles } from "lucide-react";
import api, { thumbUrl } from "@/lib/api";
import { ServiceIcon } from "@/lib/serviceIcons";

const Wrap = ({ s, children }) => {
  const cls = "group block rounded-2xl border border-zinc-800 bg-[#12141a] p-5 hover:border-[#ff6a13] hover:-translate-y-0.5 transition-all";
  const to = s.link || `/services/${s.slug}`;
  return /^https?:/i.test(to) ? <a href={to} target="_blank" rel="noreferrer" className={cls} data-testid={`service-card-${s.service_id}`}>{children}</a>
    : <Link to={to} className={cls} data-testid={`service-card-${s.service_id}`}>{children}</Link>;
};

// Home page: live list of services managed in Admin.
export const ServicesList = () => {
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data, staleTime: 60000 });
  if (services.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-testid="home-services">
      <div className="flex items-end justify-between mb-5">
        <div>
          <span className="text-xs font-mono-p uppercase tracking-widest text-[#ff6a13] inline-flex items-center gap-1.5"><Sparkles size={12} />What we do</span>
          <h2 className="font-display text-2xl sm:text-3xl font-black text-white mt-1">Our services</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {services.map((s) => (
          <Wrap key={s.service_id} s={s}>
            <div className="flex items-start justify-between gap-3">
              {s.image_url ? <img src={thumbUrl(s.image_url, 120)} alt="" className="w-11 h-11 rounded-xl object-cover border border-zinc-800" /> : <span className="w-11 h-11 rounded-xl bg-[#ff6a13]/10 border border-[#ff6a13]/30 inline-flex items-center justify-center text-[#ff6a13]"><ServiceIcon name={s.icon} size={20} /></span>}
              {s.price_from && <span className="text-xs font-mono-p text-[#ffd600] border border-[#ffd600]/40 rounded-full px-2 py-0.5">{s.price_from}</span>}
            </div>
            <h3 className="font-display text-lg font-bold text-white mt-3">{s.name}</h3>
            {s.description && <p className="text-sm text-zinc-400 mt-1.5 leading-relaxed">{s.description}</p>}
            <p className="text-sm text-[#ff6a13] font-semibold mt-4 inline-flex items-center gap-1 group-hover:gap-2 transition-all">{s.link ? "Learn more" : "Details & pricing"} <ArrowRight size={14} /></p>
          </Wrap>
        ))}
      </div>
    </section>
  );
};
